<template>
	<div class="layout">
		<div class="content" :style="{ background: Background }">
			<div id="view-box" class="view-box">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		FileName: {
			type: String
		},
		ShowHeader: {
			type: Boolean
		},
		CanDownload: {
			type: Boolean
		},
		Background: {
			type: String,
			default: '#F2F5F9'
		},
		AllowShare: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.layout {
	overflow: hidden;
	height: 100%;
	display: flex;
	flex-direction: column;

	.content {
		flex-grow: 1;
		position: relative;

		.view-box {
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			position: absolute;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.shareWps {
			right: 500px !important;
		}

		.share {
			position: absolute;
			top: 16px;
			right: 100px;
			z-index: 999;

			button {
				font-size: 12px;
				width: 50px;
				height: 22px;
				outline: none;
				background: #fff;
				border: 1px solid #e2e6ed;

				&:hover {
					background: #e8eaee;
				}

				&:active {
					background: #dae0e7;
				}
			}
		}
	}
}
</style>
